import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InformativeSeatmapSubHeaderComponent } from './informative-seatmap-sub-header.component';

@NgModule({
  declarations: [InformativeSeatmapSubHeaderComponent],
  imports: [CommonModule],
  exports: [InformativeSeatmapSubHeaderComponent],
})
export class InformativeSeatmapSubHeaderModule {}
